import { render } from "./guidance.vue?vue&type=template&id=38f5d5f8&scoped=true"
import script from "./guidance.vue?vue&type=script&lang=js"
export * from "./guidance.vue?vue&type=script&lang=js"

import "./guidance.vue?vue&type=style&index=0&id=38f5d5f8&lang=scss&scoped=true"

import exportComponent from "D:\\workFolder\\payment-H5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f5d5f8"]])

export default __exports__